module.exports = __webpack_public_path__ + "img/p6.ae711126.png";